import * as actionTypes from '../actions/actionTypes';
import moment from 'moment';

import { updateObject } from '../utility';

const intialState = {
    farePrice: [],
    generalData: null,
    ffnData: null,
    flightScheduleOneWay: null,
    fareSummaryOneWay: null,
    flightScheduleRoundTrip: null,
    fareSummaryRoundTrip: null,
    flightType: null,
    classTypeO: null,
    classTypeR: null,
    totalFare: 0,
    tduOnward: "",
    loaOnward: "",
    tduReturn: "",
    loaReturn: "",
    idac: "",
    iaac: "",
    lastTDate: null,
    error: false,
    counter: 0,
    isValid: false,
    isHff: false,
    adultCount: 0,
    childCount: 0,
    infantCount: 0,
    paxId: 1,
    isMeal: false,
    isBaggage: false,
    passengers: [],
    showDOB: false,
    totalPaxConstant: 0,
    filteredPax: [],
    paxCounter: 0,
    editPax: null,
    loadingPrimary: true,
    loadingSecondary: true,
    userParams: {
        additionalContact: {
            email: '',
            mobile: '',
            mobileISD: '91',
            isEmailValid: false
        },
        emailId: '',
        mobileNo: '',
        userId: '',
        title: '',
        firstName: '',
        lastName: '',
        mobileNoISD: ''
    },
    isGstMandatory: false,
    gstNumber: '',
    companyName: '',
    email: '',
    mobileNumber: '',
    isdCode: '91',
    selectedOption: {
        value : "91",
        label : "+ 91"
    },
    isGstAdded: false,
    mealsViewOneWay: null,
    mealsViewReturn: null,
    mealsViewOneWayVal: 0,
    mealsViewReturnVal: 0,
    baggageViewOneWay: null,
    baggageViewReturn: null,
    baggageViewOneWayVal: 0,
    baggageViewReturnVal: 0,
    seatsViewOneWay: null,
    seatsViewReturn: null,
    seatsViewOneWayVal: 0,
    seatsViewReturnVal: 0,
    mealsFlow: 'O',
    baggageFlow: 'O',
    seatsFlow: 'O',
    baggageWeight: null,
    selectedMeals: {
        O: {},
        R: {}
    },
    selectedBaggage: {
        O: {},
        R: {}
    },
    savedBaggage: {},
    savedSeat: {},
    selectedSeats: [],
    mealChanged: false,
    showBaggageView: 'initial',
    savedBaggagePaxId: [],
    displayPax: true,
    addonList: null,
    showTravellerInsurance: false,
    isBBG: false,
    isSDFC: false,
    isInsuranceAdded: true,
    isAssureAdded: true,
    dfcBenefits: null,
    showBaggageIndex: 10,
    isPassport: false,
    totalMealsSelected: 0,
    totalBaggageSelected: 0,
    timeoutTime: null
}

let isEmailValid = false;
let selectedSeats = [];
let tduOnward = null;
let loaOnward = null;
let tduReturn = null;
let loaReturn = null;

const reducer = (state = intialState, action) => {
    switch(action.type) {
        case actionTypes.SET_FARE_PRICE_LOADING:
            return updateObject(state, {
                loadingPrimary: true,
                loadingSecondary: true
            });
        case actionTypes.SET_FARE_PRICE:
            let loadingPrimary = true;
            let loadingSecondary = true;
            if (action.loadingType === 'primary') {
                loadingPrimary = false;
            } else if (action.loadingType === 'secondary') {
                loadingPrimary = false;
                loadingSecondary = false;
            }
            let generalData = null;
            let flightScheduleOneWay = null;
            let fareSummaryOneWay = null;
            let flightScheduleRoundTrip = null;
            let fareSummaryRoundTrip = null;
            let addonList = [];
            let showTravellerInsurance = false;
            let isBBG = false;
            let isSDFC = false;
            let isMeal = false;
            let isBaggage = false;
            let isSeats = false;
            let isHff = false;
            let selectedMeals = {
                O: {},
                R: {}
            };
            let selectedBaggage = {
                O: {},
                R: {}
            };
            let totalFare = 0;
            let flightType = "O";
            let idac = "";
            let iaac = "";
            let classTypeO = null;
            let classTypeR = null;
            let isPassport = false;
            generalData = action.price;
            flightType = generalData.data.ftype;
            if(generalData.data.passport === "") {
                isPassport = true;
            } else {
                isPassport = false;
            }
            if(flightType === 'O') {
                for (var oKey in generalData.data.fltSchedule) {
                    if (generalData.data.fltSchedule.hasOwnProperty(oKey)) {
                        if(!action.isPolling) {
                            tduOnward = generalData.data.fltSchedule[oKey][0].OD[0].tdu;
                            loaOnward = generalData.data.fltSchedule[oKey][0].OD[0].FS[0].loa;
                        }
                        flightScheduleOneWay = generalData.data.fltSchedule[oKey][0].OD;
                        classTypeO = flightScheduleOneWay[0].FS[0].classType;         
                        fareSummaryOneWay = generalData.data.fareDetails[oKey][generalData.data.fltSchedule[oKey][0].ID].O;
                        idac = generalData.data.fltSchedule[oKey][0].idac;
                        iaac = generalData.data.fltSchedule[oKey][0].iaac;
                        totalFare = parseInt(fareSummaryOneWay.ADT.tf, 10);
                      }                    
                }
            } else {
                if((generalData.countryCodes.origin !== 'IN' || generalData.countryCodes.dest !== 'IN') || (generalData.countryCodes.origin === 'IN' && generalData.countryCodes.dest === 'IN' && generalData.data.isSR === "true")) {
                    for (var rKey in generalData.data.fltSchedule) {
                        if(!action.isPolling) {
                            tduOnward = generalData.data.fltSchedule[rKey][0].OD[0].tdu;
                            loaOnward = generalData.data.fltSchedule[rKey][0].OD[0].FS[0].loa;
                            tduReturn = generalData.data.fltSchedule[rKey][0].OD[1].tdu;
                            loaReturn = generalData.data.fltSchedule[rKey][0].OD[1].FS[0].loa;  
                            idac = generalData.data.fltSchedule[rKey][0].idac;
                            iaac = generalData.data.fltSchedule[rKey][0].iaac;
                        }
                        flightScheduleOneWay = [generalData.data.fltSchedule[rKey][0].OD[0]];
                        flightScheduleRoundTrip = [generalData.data.fltSchedule[rKey][0].OD[1]];
                        fareSummaryOneWay = generalData.data.fareDetails[rKey][generalData.data.fltSchedule[rKey][0].ID].O;
                        fareSummaryRoundTrip = generalData.data.fareDetails[rKey][generalData.data.fltSchedule[rKey][0].ID].O;
                        totalFare = parseInt(fareSummaryOneWay.ADT.tf, 10) + parseInt(fareSummaryRoundTrip.ADT.tf, 10);
                    }
                } else {
                    const flightCode = action.flightCode.split(",")[0];
                    const flightCodeRound = action.flightCode.split(",")[1];
                    if(!action.isPolling) {
                        tduOnward = generalData.data.fltSchedule[flightCode][0].OD[0].tdu;
                        loaOnward = generalData.data.fltSchedule[flightCode][0].OD[0].FS[0].loa;
                        idac = generalData.data.fltSchedule[flightCode][0].idac;
                        iaac = generalData.data.fltSchedule[flightCode][0].iaac;  
                        tduReturn = generalData.data.fltSchedule[flightCodeRound][0].OD[0].tdu;
                        loaReturn = generalData.data.fltSchedule[flightCodeRound][0].OD[0].FS[0].loa;
                    }
                    flightScheduleOneWay = generalData.data.fltSchedule[flightCode][0].OD;   
                    classTypeO = flightScheduleOneWay[0].FS[0].classType;  
                    fareSummaryOneWay = generalData.data.fareDetails[flightCode][generalData.data.fltSchedule[flightCode][0].ID].O;
                    flightScheduleRoundTrip = generalData.data.fltSchedule[flightCodeRound][0].OD;
                    classTypeR = flightScheduleRoundTrip[0].FS[0].classType;
                    fareSummaryRoundTrip = generalData.data.fareDetails[flightCodeRound][generalData.data.fltSchedule[flightCodeRound][0].ID].O;
                    totalFare = parseInt(fareSummaryOneWay.ADT.tf, 10) + parseInt(fareSummaryRoundTrip.ADT.tf, 10);
                }
            }
            if(generalData.countryCodes.origin !== 'IN' || generalData.countryCodes.dest !== 'IN') {
                if(generalData.data.isHff) {
                    isHff = JSON.parse(generalData.data.isHff);
                }
            }
            const adultCount = parseInt(generalData.data.adtCount, 10);
            const childCount = parseInt(generalData.data.chdCount, 10);
            const infantCount = parseInt(generalData.data.infCount, 10);
            let mealsViewOneWay = state.mealsViewOneWay;
            let mealsViewReturn = state.mealsViewReturn;
            let baggageViewOneWay = state.baggageViewOneWay;
            let baggageViewReturn = state.mealsViewReturn;
            let seatsViewOneWay = state.seatsViewOneWay;
            let seatsViewReturn = state.seatsViewReturn;
            let paxCounter = null;
            let timeoutTime = null;
            if (state.passengers.length > 0) {
                paxCounter = state.paxCounter;
            } else {
                paxCounter = adultCount + childCount + infantCount;
            }
            let isValid = false;
            if (paxCounter === 1) {
              isValid = true;
            }
            if(!action.price.shouldRetry) {
                isMeal = generalData.data.meals.isMeal;
                isBaggage = generalData.data.baggage.isbaggage;
                isSeats = generalData.data.seats.O ? true: false;
                if(generalData.addonList !== null) {
                    for(let i = 0; i < generalData.addonList.length; i++) {
                        if(generalData.addonList[i].checked) {
                            addonList.push(generalData.addonList[i]);
                        }
                        if(generalData.addonList[i].addonLabel === "Travel Assistance and Insurance") {
                            showTravellerInsurance = true;
                        }
                        if(generalData.addonList[i].addonCode === "SDFC") {
                            isSDFC = true;
                        }
                        if(generalData.addonList[i].addonCode === "BBG") {
                            isBBG = true;
                        }                    
                    }
                }
                if(JSON.parse(isMeal) === true) {
                    if(flightType === 'O') {
                        mealsViewOneWay = Object.keys(generalData.data.meals.O)[0];
                        for(let i=0; i < Object.keys(generalData.data.meals.O).length; i++) {
                            selectedMeals.O[Object.keys(generalData.data.meals.O)[i]] = {};
                        }
                    } else {
                        mealsViewOneWay = Object.keys(generalData.data.meals.O)[0];
                        for(let i=0; i < Object.keys(generalData.data.meals.O).length; i++) {
                            selectedMeals.O[Object.keys(generalData.data.meals.O)[i]] = {};
                        }
                        mealsViewReturn = Object.keys(generalData.data.meals.R)[0];
                        for(let i=0; i < Object.keys(generalData.data.meals.R).length; i++) {
                            selectedMeals.R[Object.keys(generalData.data.meals.R)[i]] = {};
                        }
                    }
                }
                if(JSON.parse(isBaggage) === true) {
                    if(flightType === "O") {
                        baggageViewOneWay = Object.keys(generalData.data.baggage.O)[0];
                        for (let i=0; i < Object.keys(generalData.data.baggage.O).length; i++) {
                            selectedBaggage.O[Object.keys(generalData.data.baggage.O)[i]] = {};
                        }
                    } else {
                        baggageViewOneWay = Object.keys(generalData.data.baggage.O)[0];
                        for(let i=0; i < Object.keys(generalData.data.baggage.O).length; i++) {
                            selectedBaggage.O[Object.keys(generalData.data.baggage.O)[i]] = {};
                        }
                        baggageViewReturn = Object.keys(generalData.data.baggage.R)[0];
                        for(let i=0; i < Object.keys(generalData.data.baggage.R).length; i++) {
                            selectedBaggage.R[Object.keys(generalData.data.baggage.R)[i]] = {};
                        }
                    }
                }
                if (isSeats) {
                    if (flightType === "O") {
                        seatsViewOneWay = Object.keys(generalData.data.seats.O)[0];
                    } else {
                        seatsViewOneWay = Object.keys(generalData.data.seats.O)[0];
                        seatsViewReturn = Object.keys(generalData.data.seats.R)[0];
                    }
                }
                sessionStorage.setItem("ttid", "11" + generalData.superPnr);
                timeoutTime = parseInt(generalData.sessionTimeoutData.timeout, 10);
            }
            return updateObject(state, {farePrice: [
                    ...state.farePrice,
                    {
                        id: action.id,
                        price: action.price
                    }
                ],
                generalData: generalData,
                tduOnward: tduOnward,
                loaOnward: loaOnward,
                tduReturn: tduReturn,
                loaReturn: loaReturn,
                idac: idac,
                iaac: iaac,
                lastTDate: generalData.data.lastTDate,
                flightScheduleOneWay: flightScheduleOneWay,
                fareSummaryOneWay: fareSummaryOneWay,
                flightScheduleRoundTrip: flightScheduleRoundTrip,
                fareSummaryRoundTrip: fareSummaryRoundTrip,
                flightType: flightType,
                classTypeO: classTypeO,
                classTypeR: classTypeR,
                totalFare: totalFare,
                isValid: isValid,
                adultCount: adultCount,
                childCount: childCount,
                infantCount: infantCount,
                paxCounter: paxCounter,
                isMeal: isMeal,
                counter: state.counter + 1,
                loadingPrimary: loadingPrimary,
                loadingSecondary: loadingSecondary,
                mealsViewOneWay: mealsViewOneWay,
                mealsViewReturn: mealsViewReturn,
                baggageViewOneWay: baggageViewOneWay,
                baggageViewReturn: baggageViewReturn,
                seatsViewOneWay: seatsViewOneWay,
                seatsViewReturn: seatsViewReturn,
                selectedMeals: selectedMeals,
                selectedBaggage: selectedBaggage,
                addonList: addonList,
                totalPaxConstant: generalData.data.passengerList.length,
                showDOB: generalData.showdob,
                isBBG: isBBG,
                isSDFC: isSDFC,
                isPassport: isPassport,
                showTravellerInsurance: showTravellerInsurance,
                dfcBenefits: generalData.data.dfcBenefits,
                isGstMandatory: generalData.isGstMandatory,
                timeoutTime: timeoutTime,
                isHff: isHff
            })
        case actionTypes.GET_FARE_PRICE_FAILED:
            return updateObject(state, {error: true, loadingPrimary: false, loadingSecondary: false})
        case actionTypes.SET_FFN_DATA:
            console.log(action.ffnData);
            return updateObject(state, { ffnData: action.ffnData });
        case actionTypes.ADD_PAX:
            let paxClass = null;
            let passengerClass = null; 
            let newAdultCount = state.adultCount;
            let newChildCount = state.childCount;
            let newInfantCount = state.infantCount;
            if (action.paxType === 'adult') {
                paxClass = 'Adult';
                passengerClass = 'ADT';
                newAdultCount = parseInt(state.adultCount, 10) - 1;
            } else if (action.paxType === 'child') {
                paxClass = 'Child';
                passengerClass = 'CHD';
                newChildCount = parseInt(state.childCount, 10) - 1;
            } else if (action.paxType === 'infant') {
                paxClass = 'Infant';
                passengerClass = 'INF';
                newInfantCount = parseInt(state.infantCount, 10) - 1;
            }
            console.log(action.dob);
            const passenger = {
                paxID: state.paxId,
                travellerDetails: {
                    id: "",
                    title: action.title,
                    firstName: action.firstName,
                    middleName: '',
                    lastName: action.lastName,
                    paxClass: paxClass,
                    passengerClass: passengerClass,
                    passport: {
                        nationality: action.nationality,
                        number: action.number,
                        issuingCountryCode: action.selectedOption ? action.selectedOption.alpha_2_code : "",
                        issuingCountryName: action.selectedOption ? action.selectedOption.label : "",
                        expiryDate: action.passportExpiryDate,
                        expiryDateRawValue: action.passportExpiryDateRawValue
                    },
                    dateOfBirth: action.dob,
                    dobRaw: action.dobRaw,
                    frequentFlyer: {
                        0: {
                            frequentFlyerNumber: action.frequentFlyerNumber,
                            ac: action.ffnSelectedOption.value,
                            an: action.ffnSelectedOption.label === "Select Here" ? "" : action.ffnSelectedOption.label
                        }
                    },
                },
                ssrDetails: {
                    ssrMealDetails: [
                        [
                            { typ: '', desc: '', amt: '', curr: '', convamt: '', isdata: '', pax: '', trip: '', uid: '', rph: '' },
                            { typ: '', desc: '', amt: '', curr: '', convamt: '', isdata: '', pax: '', trip: '', uid: '', rph: '' },
                            { typ: '', desc: '', amt: '', curr: '', convamt: '', isdata: '', pax: '', trip: '', uid: '', rph: '' }
                        ],
                        [
                            { typ: '', desc: '', amt: '', curr: '', convamt: '', isdata: '', pax: '', trip: '', uid: '', rph: '' },
                            { typ: '', desc: '', amt: '', curr: '', convamt: '', isdata: '', pax: '', trip: '', uid: '', rph: '' },
                            { typ: '', desc: '', amt: '', curr: '', convamt: '', isdata: '', pax: '', trip: '', uid: '', rph: '' }
                        ]
                    ],
                    ssrBaggageDetails: [
                        [
                            { typ: '', desc: '', amt: '', curr: '', convamt: '', isdata: '', pax: '', trip: '', uid: '', rph: '' },
                            { typ: '', desc: '', amt: '', curr: '', convamt: '', isdata: '', pax: '', trip: '', uid: '', rph: '' },
                            { typ: '', desc: '', amt: '', curr: '', convamt: '', isdata: '', pax: '', trip: '', uid: '', rph: '' }
                        ],
                        [
                            { typ: '', desc: '', amt: '', curr: '', convamt: '', isdata: '', pax: '', trip: '', uid: '', rph: '' },
                            { typ: '', desc: '', amt: '', curr: '', convamt: '', isdata: '', pax: '', trip: '', uid: '', rph: '' },
                            { typ: '', desc: '', amt: '', curr: '', convamt: '', isdata: '', pax: '', trip: '', uid: '', rph: '' }
                        ]
                    ],
                    ssrSeatDetails: [
                        [
                            { seatValue: '', price: '', isdata: '', arrloc: '', deploc: '', pax: '', trip: '', uid: '', rph: '' },
                            { seatValue: '', price: '', isdata: '', arrloc: '', deploc: '', pax: '', trip: '', uid: '', rph: '' },
                            { seatValue: '', price: '', isdata: '', arrloc: '', deploc: '', pax: '', trip: '', uid: '', rph: '' }
                        ],
                        [
                            { seatValue: '', price: '', isdata: '', arrloc: '', deploc: '', pax: '', trip: '', uid: '', rph: '' },
                            { seatValue: '', price: '', isdata: '', arrloc: '', deploc: '', pax: '', trip: '', uid: '', rph: '' },
                            { seatValue: '', price: '', isdata: '', arrloc: '', deploc: '', pax: '', trip: '', uid: '', rph: '' }
                        ]
                    ],
                    ssrOtherDetails: []
                },
                isSelected: action.isSelected,
                isMeal: false
            };
            const oldPassengers = [...state.passengers];
            const updatedPassengers = oldPassengers.concat(passenger);
            return {
                ...state,
                passengers: updatedPassengers,
                adultCount: newAdultCount,
                childCount: newChildCount,
                infantCount: newInfantCount,
                paxCounter: parseInt(state.paxCounter, 10) - 1,
                paxId: state.paxId + 1,
                editPax: null
            }
        case actionTypes.ADD_ONLY_PAX:
            let singlePassenger = null;
            let singlePassengersCopy = [...state.passengers];
            const isPassengerAdded = state.passengers.length === 1 ? true : false; 
            if(isPassengerAdded) {
                singlePassenger = JSON.parse(JSON.stringify(state.passengers[0]));
                singlePassenger.travellerDetails.title = action.title;
                singlePassenger.travellerDetails.firstName = action.firstName;
                singlePassenger.travellerDetails.lastName = action.lastName;
                singlePassenger.travellerDetails.passport.nationality = action.nationality;
                singlePassenger.travellerDetails.passport.number = action.number;
                singlePassenger.travellerDetails.passport.issuingCountryCode = action.selectedOption ? action.selectedOption.alpha_2_code : "";
                singlePassenger.travellerDetails.passport.issuingCountryName = action.selectedOption ? action.selectedOption.label : "";
                singlePassenger.travellerDetails.passport.expiryDate = action.passportExpiryDate;
                singlePassenger.travellerDetails.passport.passportExpiryDateRawValue = action.passportExpiryDateRawValue;
                singlePassenger.travellerDetails.dateOfBirth = action.dob;
                singlePassenger.travellerDetails.dobRaw = action.dobRaw;
                singlePassenger.travellerDetails.frequentFlyer[0].frequentFlyerNumber = action.frequentFlyerNumber;
                singlePassenger.travellerDetails.frequentFlyer[0].ac = action.ffnSelectedOption.value;
                singlePassenger.travellerDetails.frequentFlyer[0].an = action.ffnSelectedOption.label === "Select Here" ? "" : action.ffnSelectedOption.label;
                singlePassenger.isSelected = action.isSelected;
            } else {
                singlePassenger = {
                    paxID: state.paxId,
                    travellerDetails: {
                        id: "",
                        title: action.title,
                        firstName: action.firstName,
                        middleName: '',
                        lastName: action.lastName,
                        paxClass: 'Adult',
                        passengerClass: "ADT",
                        passport: {
                            nationality: action.nationality,
                            number: action.number,
                            issuingCountryCode: action.selectedOption ? action.selectedOption.alpha_2_code : "",
                            issuingCountryName: action.selectedOption ? action.selectedOption.label : "",
                            expiryDate: action.passportExpiryDate,
                            expiryDateRawValue: action.passportExpiryDateRawValue
                        },
                        dateOfBirth: action.dob,
                        dobRaw: action.dobRaw,
                        frequentFlyer: {
                            0: {
                                frequentFlyerNumber: action.frequentFlyerNumber,
                                ac: action.ffnSelectedOption.value,
                                an: action.ffnSelectedOption.label === "Select Here" ? "" : action.ffnSelectedOption.label
                            }
                        },
                    },
                    ssrDetails: {
                        ssrMealDetails: [
                            [
                                { typ: '', desc: '', amt: '', curr: '', convamt: '', isdata: '', pax: '', trip: '', uid: '', rph: '' },
                                { typ: '', desc: '', amt: '', curr: '', convamt: '', isdata: '', pax: '', trip: '', uid: '', rph: '' },
                                { typ: '', desc: '', amt: '', curr: '', convamt: '', isdata: '', pax: '', trip: '', uid: '', rph: '' }
                            ],
                            [
                                { typ: '', desc: '', amt: '', curr: '', convamt: '', isdata: '', pax: '', trip: '', uid: '', rph: '' },
                                { typ: '', desc: '', amt: '', curr: '', convamt: '', isdata: '', pax: '', trip: '', uid: '', rph: '' },
                                { typ: '', desc: '', amt: '', curr: '', convamt: '', isdata: '', pax: '', trip: '', uid: '', rph: '' }
                            ]
                        ],
                        ssrBaggageDetails: [
                            [
                                { typ: '', desc: '', amt: '', curr: '', convamt: '', isdata: '', pax: '', trip: '', uid: '', rph: '' },
                                { typ: '', desc: '', amt: '', curr: '', convamt: '', isdata: '', pax: '', trip: '', uid: '', rph: '' },
                                { typ: '', desc: '', amt: '', curr: '', convamt: '', isdata: '', pax: '', trip: '', uid: '', rph: '' }
                            ],
                            [
                                { typ: '', desc: '', amt: '', curr: '', convamt: '', isdata: '', pax: '', trip: '', uid: '', rph: '' },
                                { typ: '', desc: '', amt: '', curr: '', convamt: '', isdata: '', pax: '', trip: '', uid: '', rph: '' },
                                { typ: '', desc: '', amt: '', curr: '', convamt: '', isdata: '', pax: '', trip: '', uid: '', rph: '' }
                            ]
                        ],
                        ssrSeatDetails: [
                            [
                                { seatValue: '', price: '', isdata: '', arrloc: '', deploc: '', pax: '', trip: '', uid: '', rph: '' },
                                { seatValue: '', price: '', isdata: '', arrloc: '', deploc: '', pax: '', trip: '', uid: '', rph: '' },
                                { seatValue: '', price: '', isdata: '', arrloc: '', deploc: '', pax: '', trip: '', uid: '', rph: '' }
                            ],
                            [
                                { seatValue: '', price: '', isdata: '', arrloc: '', deploc: '', pax: '', trip: '', uid: '', rph: '' },
                                { seatValue: '', price: '', isdata: '', arrloc: '', deploc: '', pax: '', trip: '', uid: '', rph: '' },
                                { seatValue: '', price: '', isdata: '', arrloc: '', deploc: '', pax: '', trip: '', uid: '', rph: '' }
                            ]
                        ],
                        ssrOtherDetails: []
                    },
                    isSelected: action.isSelected,
                    isMeal: false
                };
            }
            singlePassengersCopy[0] = singlePassenger;
            const previousDate = moment().subtract(12, "years");
            const diff = moment(action.dob, 'DD/MM/YYYY').diff(previousDate, 'days');            
            if((state.showDOB && action.title && action.firstName && action.lastName && action.dobRaw && (diff < 0 && diff > -31643)) || (!state.showDOB && action.title && action.firstName && action.lastName) || ((state.generalData.countryCodes.origin !== 'IN' || state.generalData.countryCodes.dest !== 'IN') && action.title && action.firstName && action.lastName && action.dobRaw && (diff < 0 && diff > -31643))) {
                return {
                    ...state,
                    passengers: singlePassengersCopy,
                    paxCounter: 0
                }
            } else {
                return {
                    ...state,
                    passengers: singlePassengersCopy,
                    paxCounter: 1
                }
            }
        case actionTypes.EDIT_PAX:
            let updatedAdultNumber = state.adultCount;
            let updatedChildNumber = state.childCount;
            let updatedInfantNumber = state.infantCount; 
            const editPassenger = state.passengers.filter(passenger => passenger.paxID === action.id);
            const editPassengerCopy = JSON.parse(JSON.stringify(editPassenger));
            const editPassengerCounter = editPassengerCopy[0].isSelected ? parseInt(state.paxCounter, 10) + 1 : parseInt(state.paxCounter, 10);
            let paxtype = editPassengerCopy[0].travellerDetails.passengerClass;
            if(editPassengerCopy[0].isSelected) {
                if (paxtype === 'ADT') {
                    updatedAdultNumber += 1;
                } else if (paxtype === 'CHD') {
                    updatedChildNumber += 1;
                } else if (paxtype === 'INF') {
                    updatedInfantNumber += 1;
                }
            }
            return {
                ...state,
                editPax: state.passengers.filter(passenger => passenger.paxID === action.id),
                passengers: state.passengers.filter(passenger => passenger.paxID !== action.id),
                paxCounter: editPassengerCounter,
                adultCount: updatedAdultNumber,
                childCount: updatedChildNumber,
                infantCount: updatedInfantNumber
            }
        case actionTypes.DELETE_PAX:
            console.log("Reached heree");
            let updatedAdultNum = state.adultCount;
            let updatedChildNum = state.childCount;
            let updatedInfantNum = state.infantCount; 
            const deletePassenger = state.passengers.filter(passenger => passenger.paxID === action.id);
            const deletePassengerCopy = JSON.parse(JSON.stringify(deletePassenger));
            const deletePassengerCounter = deletePassengerCopy[0].isSelected ? parseInt(state.paxCounter, 10) + 1 : parseInt(state.paxCounter, 10); 
            let paxType = deletePassengerCopy[0].travellerDetails.passengerClass;
            if(deletePassengerCopy[0].isSelected) {
                if (paxType === 'ADT') {
                    updatedAdultNum += 1;
                } else if (paxType === 'CHD') {
                    updatedChildNum += 1;
                } else if (paxType === 'INF') {
                    updatedInfantNum += 1;
                }
            }
            console.log(updatedAdultNum);

            return {
                ...state,
                passengers: state.passengers.filter(passenger => passenger.paxID !== action.id),
                paxCounter: deletePassengerCounter,
                adultCount: updatedAdultNum,
                childCount: updatedChildNum,
                infantCount: updatedInfantNum 
            }
        case actionTypes.CLEAR_PAX:
            return {
                ...state,
                passengers: []
            }
        case actionTypes.TOGGLE_PAX:
            let updatedAdultCount = state.adultCount;
            let updatedChildCount = state.childCount;
            let updatedInfantCount = state.infantCount;
            const selectedPassenger = state.passengers.filter(passenger => passenger.paxID === action.id);
            const selectedPassengerCopy = JSON.parse(JSON.stringify(selectedPassenger[0]));
            console.log(selectedPassengerCopy.isSelected);
            selectedPassengerCopy.isSelected = !selectedPassenger[0].isSelected;
            console.log(selectedPassengerCopy.isSelected);
            if (!selectedPassengerCopy.isSelected) {
                let type = selectedPassenger[0].travellerDetails.passengerClass;
                if (type === 'ADT') {
                    updatedAdultCount += 1;
                } else if (type === 'CHD') {
                    updatedChildCount += 1;
                } else if (type === 'INF') {
                    updatedInfantCount += 1;
                }
            } else {
                let type = selectedPassenger[0].travellerDetails.passengerClass;
                if (type === 'ADT') {
                    updatedAdultCount -= 1;
                } else if (type === 'CHD') {
                    updatedChildCount -= 1;
                } else if (type === 'INF') {
                    updatedInfantCount -= 1;
                }
            }
            const passengers = JSON.parse(JSON.stringify(state.passengers));
            const index = state.passengers.findIndex(passenger => passenger.paxID === action.id);
            passengers[index] = selectedPassengerCopy;
            const passengerCounter = selectedPassengerCopy.isSelected ? parseInt(state.paxCounter, 10) - 1 : parseInt(state.paxCounter, 10) + 1;
            return {
                ...state,
                passengers: passengers,
                paxCounter: passengerCounter,
                adultCount: updatedAdultCount,
                childCount: updatedChildCount,
                infantCount: updatedInfantCount
            }
        case actionTypes.SET_USER_DETAILS:
            if(action.valType === "email") {
                isEmailValid = validateEmail(action.val);
            }
            return {
                ...state,
                userParams: {
                    ...state.userParams,
                    additionalContact: {
                        ...state.userParams.additionalContact,
                        [action.valType]: action.val,
                        isEmailValid: isEmailValid,
                    }
                }
            }
        case actionTypes.TOGGLE_BAGGAGE_VIEW:
            let baggageViewO = state.baggageViewOneWay;
            let baggageViewR = state.baggageViewReturn;
            let baggageViewOVal = state.baggageViewOneWayVal;
            let baggageViewRVal = state.baggageViewReturnVal;
            let baggageFlow = state.baggageFlow;
            if(action.tripType === 'depart') {
                baggageViewO = action.val;
                baggageFlow = 'O';
                baggageViewOVal = action.index;
            } else {
                baggageViewR = action.val;
                baggageFlow = 'R';
                baggageViewRVal = action.index;
            }
        return {
            ...state,
            baggageViewOneWay: baggageViewO,
            baggageViewReturn: baggageViewR,
            baggageFlow: baggageFlow,
            baggageViewOneWayVal: baggageViewOVal,
            baggageViewReturnVal: baggageViewRVal
        }
        case actionTypes.TOGGLE_MEALS_VIEW:
            let mealsViewO = state.mealsViewOneWay;
            let mealsViewR = state.mealsViewReturn;
            let mealsViewOVal = state.mealsViewOneWayVal;
            let mealsViewRVal = state.mealsViewReturnVal;
            let mealsFlow = state.mealsFlow
            if (action.tripType === 'depart') {
                mealsViewO = action.val;
                mealsFlow = 'O';
                mealsViewOVal = action.index;
            } else {
                mealsViewR = action.val;
                mealsFlow = 'R';
                mealsViewRVal = action.index;
            }
            return {
                ...state,
                mealsViewOneWay: mealsViewO,
                mealsViewReturn: mealsViewR,
                mealsFlow: mealsFlow,
                mealsViewOneWayVal: mealsViewOVal,
                mealsViewReturnVal: mealsViewRVal
            }
        case actionTypes.TOGGLE_SEATS_VIEW: 
            let seatsViewO = state.seatsViewOneWay;
            let seatsViewR = state.seatsViewReturn;
            let seatsViewOVal = state.seatsViewOneWayVal;
            let seatsViewRVal = state.seatsViewReturnVal;
            let seatsFlow = state.seatsFlow;
            if (action.tripType === 'depart') {
                seatsViewO = action.val;
                seatsFlow = 'O';
                seatsViewOVal = action.index;
            } else {
                seatsViewR = action.val;
                seatsFlow = 'R';
                seatsViewRVal = action.index;
            }
            return {
                ...state,
                seatsViewOneWay: seatsViewO,
                seatsViewReturn: seatsViewR,
                seatsFlow: seatsFlow,
                seatsViewOneWayVal: seatsViewOVal,
                seatsViewReturnVal: seatsViewRVal
            }
        case actionTypes.SAVE_MEAL:
            if(Object.keys(state.selectedMeals[state.mealsFlow]).length !== 0 && (action.val.typ === state.selectedMeals[state.mealsFlow][state.mealsFlow === 'O' ? state.mealsViewOneWay : state.mealsViewReturn].typ)) {
                return {
                    ...state,
                    selectedMeals: {
                        ...state.selectedMeals,
                        [state.mealsFlow]: {
                            ...state.selectedMeals[state.mealsFlow],
                            [state.mealsFlow === 'O' ? state.mealsViewOneWay : state.mealsViewReturn]: {}
                        }
                    }
                }
            }
            return {
                ...state,
                selectedMeals: {
                    ...state.selectedMeals,
                    [state.mealsFlow]: {
                        ...state.selectedMeals[state.mealsFlow],
                        [state.mealsFlow === 'O' ? state.mealsViewOneWay : state.mealsViewReturn]: action.val
                    }
                },
            }
        case actionTypes.SAVE_BAGGAGE:
            if(Object.keys(state.selectedBaggage[state.baggageFlow]).length !== 0 && (action.val.typ === state.selectedBaggage[state.baggageFlow][state.baggageFlow === 'O' ? state.baggageViewOneWay : state.baggageViewReturn].typ)) {
                console.log(state.selectedBaggage[state.baggageFlow]);
                return {
                    ...state,
                    selectedBaggage: {
                        ...state.selectedBaggage,
                        [state.baggageFlow]: {
                            ...state.selectedBaggage[state.baggageFlow],
                            [state.baggageFlow === 'O' ? state.baggageViewOneWay : state.baggageViewReturn]: {}
                        }
                    }
                }
            }
            return {
                ...state,
                selectedBaggage: {
                    ...state.selectedBaggage,
                    [state.baggageFlow]: {
                        ...state.selectedBaggage[state.baggageFlow],
                        [state.baggageFlow === 'O' ? state.baggageViewOneWay : state.baggageViewReturn]: action.val
                    }
                },
            }
        case actionTypes.SELECT_MEAL:
            let paxMeal = [...state.passengers];
            let totalMeals = 0;
            let tempPaxMeal = paxMeal.filter(pax => {
                return pax.paxID === action.val;
            })
            tempPaxMeal[0].ssrDetails.ssrMealDetails[action.flow === 'O' ? 0 : 1][action.flow === 'O' ? state.mealsViewOneWayVal : state.mealsViewReturnVal] = {...state.selectedMeals[action.flow][action.flow === 'O' ? state.mealsViewOneWay : state.mealsViewReturn]};

            let paxIdMeal = paxMeal.findIndex((pax) => {
                return pax.paxID === action.val;
            });
            paxMeal[paxIdMeal] = tempPaxMeal[0];
            console.log(paxMeal);
            for(let i = 0; i < paxMeal.length; i++) {
                const mealsArrayOnward = paxMeal[i].ssrDetails.ssrMealDetails[0];
                const mealsArrayReturm = paxMeal[i].ssrDetails.ssrMealDetails[1];

                for(let j = 0; j < mealsArrayOnward.length; j++) {
                    if(mealsArrayOnward[j].typ !== "") {
                        totalMeals += 1;
                    }
                }
                for(let j = 0; j < mealsArrayReturm.length; j++) {
                    if(mealsArrayReturm[j].typ !== "") {
                        totalMeals += 1;
                    }
                }
            }


            return {
                ...state,
                passengers: paxMeal,
                totalMealsSelected: totalMeals
            }
        case actionTypes.SELECT_BAGGAGE:
            let paxBaggage = [...state.passengers];
            let totalBaggage = 0;
            let tempPaxBaggage = paxBaggage.filter(pax => {
                return pax.paxID === action.val;
            });
            console.log(tempPaxBaggage);
            tempPaxBaggage[0].ssrDetails.ssrBaggageDetails[action.flow === 'O' ? 0 : 1][action.flow === 'O' ? state.baggageViewOneWayVal : state.baggageViewReturnVal] = {...state.selectedBaggage[action.flow][action.flow === 'O' ? state.baggageViewOneWay : state.baggageViewReturn]};

            let paxIdBaggage = paxBaggage.findIndex(pax => {
                return pax.paxID === action.val;
            });
            paxBaggage[paxIdBaggage] = tempPaxBaggage[0];
            console.log(paxBaggage);
            for(let i = 0; i < paxBaggage.length; i++) {
                const baggageArrayOnward = paxBaggage[i].ssrDetails.ssrBaggageDetails[0];
                const baggageArrayReturm = paxBaggage[i].ssrDetails.ssrBaggageDetails[1];

                for(let j = 0; j < baggageArrayOnward.length; j++) {
                    if(baggageArrayOnward[j].typ !== "") {
                        totalBaggage += 1;
                    }
                }
                for(let j = 0; j < baggageArrayReturm.length; j++) {
                    if(baggageArrayReturm[j].typ !== "") {
                        totalBaggage += 1;
                    }
                }
            }
            return {
                ...state,
                passengers: paxBaggage,
                totalBaggageSelected: totalBaggage
            }
        case actionTypes.DESELECT_MEAL:
            let pax = [...state.passengers];
            let totalMealsSelected = state.totalMealsSelected;
            let tempPax = pax.filter(pax => {
                return pax.paxID === action.val;
            })
            Object.keys(tempPax[0].ssrDetails.ssrMealDetails[action.flow === 'O' ? 0 : 1][action.flow === 'O' ? state.mealsViewOneWayVal : state.mealsViewReturnVal]).forEach(key => tempPax[0].ssrDetails.ssrMealDetails[action.flow === 'O' ? 0 : 1][action.flow === 'O' ? state.mealsViewOneWayVal : state.mealsViewReturnVal][key] = '');
            let paxId = pax.findIndex((pax) => {
                return pax.paxID === action.val;
            });
            pax[paxId] = tempPax[0];
            totalMealsSelected -= 1;
            return {
                ...state,
                passengers: pax,
                totalMealsSelected: totalMealsSelected
            }
        case actionTypes.DESELECT_BAGGAGE:
            let paxes = [...state.passengers];
            let totalBaggageSelected = state.totalBaggageSelected;
            let tempPaxes = paxes.filter(pax => {
                return pax.paxID === action.val;
            });
            Object.keys(tempPaxes[0].ssrDetails.ssrBaggageDetails[action.flow === 'O' ? 0 : 1][action.flow === 'O' ? state.baggageViewOneWayVal: state.baggageViewReturnVal]).forEach(key => tempPaxes[0].ssrDetails.ssrBaggageDetails[action.flow === 'O' ? 0 : 1][action.flow === 'O' ? state.baggageViewOneWayVal : state.baggageViewReturnVal][key] = '');
            let paxesID = paxes.findIndex((pax) => {
                return pax.paxID === action.val;
            });
            paxes[paxesID] = tempPaxes[0];
            totalBaggageSelected -= 1;
            return {
                ...state,
                passengers: paxes,
                totalBaggageSelected: totalBaggageSelected
            }
        case actionTypes.SAVE_SEAT:
            let seat = {};
            seat.seatValue = action.val.sn;
            seat.price = action.val.price;
            seat.isdata = true;
            seat.trip = state.seatsFlow;
            seat.arrloc = state.seatsFlow === 'O' ? state.seatsViewOneWay.split('|')[1] : state.seatsViewReturn.split('|')[1];
            seat.deploc = state.seatsFlow === 'O' ? state.seatsViewOneWay.split('|')[0] : state.seatsViewReturn.split('|')[0];
            return {
                ...state,
                savedSeat: seat
            };
        case actionTypes.SELECT_SEAT:
            let tPassengers = [...state.passengers];
            let tPassenger = tPassengers.filter(pax => {
                return pax.paxID === action.val;
            })
            tPassenger[0].ssrDetails.ssrSeatDetails[action.flow === 'O' ? 0 : 1][action.flow === 'O' ? state.seatsViewOneWayVal : state.seatsViewReturnVal] = {...state.savedSeat};
            let pId = tPassengers.findIndex(pax => {
                return pax.paxID === action.val;
            });
            tPassengers[pId] = tPassenger[0];
            selectedSeats.push(tPassenger[0].ssrDetails.ssrSeatDetails[action.flow === 'O' ? 0 : 1][action.flow === 'O' ? state.seatsViewOneWayVal : state.seatsViewReturnVal].seatValue);
            return {
                ...state,
                passengers: tPassengers,
                selectedSeats: selectedSeats
            };
        case actionTypes.DESELECT_SEAT:
            let temporaryPassengers = [...state.passengers];
            let temporaryPassenger = temporaryPassengers.filter(pax => {
                return pax.paxID === action.val;
            });

            const seatIndex = selectedSeats.indexOf(temporaryPassenger[0].ssrDetails.ssrSeatDetails[action.flow === 'O' ? 0 : 1][action.flow === 'O' ? state.seatsViewOneWayVal : state.seatsViewReturnVal].seatValue);
            if (seatIndex > -1) {
                selectedSeats.splice(seatIndex, 1);
            }

            temporaryPassenger[0].ssrDetails.ssrSeatDetails[action.flow === 'O' ? 0 : 1][action.flow === 'O' ? state.seatsViewOneWayVal : state.seatsViewReturnVal].seatValue = "";
            temporaryPassenger[0].ssrDetails.ssrSeatDetails[action.flow === 'O' ? 0 : 1][action.flow === 'O' ? state.seatsViewOneWayVal : state.seatsViewReturnVal].price = "";
            temporaryPassenger[0].ssrDetails.ssrSeatDetails[action.flow === 'O' ? 0 : 1][action.flow === 'O' ? state.seatsViewOneWayVal : state.seatsViewReturnVal].isdata = "";
            temporaryPassenger[0].ssrDetails.ssrSeatDetails[action.flow === 'O' ? 0 : 1][action.flow === 'O' ? state.seatsViewOneWayVal : state.seatsViewReturnVal].arrloc = "";
            temporaryPassenger[0].ssrDetails.ssrSeatDetails[action.flow === 'O' ? 0 : 1][action.flow === 'O' ? state.seatsViewOneWayVal : state.seatsViewReturnVal].deploc = "";
            temporaryPassenger[0].ssrDetails.ssrSeatDetails[action.flow === 'O' ? 0 : 1][action.flow === 'O' ? state.seatsViewOneWayVal : state.seatsViewReturnVal].pax = "";
            temporaryPassenger[0].ssrDetails.ssrSeatDetails[action.flow === 'O' ? 0 : 1][action.flow === 'O' ? state.seatsViewOneWayVal : state.seatsViewReturnVal].trip = "";
            temporaryPassenger[0].ssrDetails.ssrSeatDetails[action.flow === 'O' ? 0 : 1][action.flow === 'O' ? state.seatsViewOneWayVal : state.seatsViewReturnVal].uid = "";
            temporaryPassenger[0].ssrDetails.ssrSeatDetails[action.flow === 'O' ? 0 : 1][action.flow === 'O' ? state.seatsViewOneWayVal : state.seatsViewReturnVal].rph = "";

            let passengerId = temporaryPassengers.findIndex(pax => {
                return pax.paxID === action.val;
            });
            temporaryPassengers[passengerId] = temporaryPassenger[0];
            return {
                ...state,
                passengers: temporaryPassengers,
                selectedSeats: selectedSeats
            };
        case actionTypes.CHANGE_MEALS_FLOW:
            return {
                mealsFlow: action.val
            }
        case actionTypes.RESET_FARE_PRICE:
            return {
                ...state,
                farePrice: [],
                generalData: null,
                ffnData: null,
                flightScheduleOneWay: null,
                fareSummaryOneWay: null,
                flightScheduleRoundTrip: null,
                fareSummaryRoundTrip: null,
                flightType: null,
                classTypeO: null,
                classTypeR: null,
                totalFare: 0,
                tduOnward: "",
                loaOnward: "",
                tduReturn: "",
                loaReturn: "",
                idac: "",
                iaac: "",
                error: false,
                counter: 0,
                isValid: false,
                isHff: false,
                adultCount: 0,
                childCount: 0,
                infantCount: 0,
                paxId: 1,
                isMeal: false,
                isBaggage: false,
                passengers: [],
                showDOB: false,
                totalPaxConstant: 0,
                filteredPax: [],
                paxCounter: 0,
                editPax: null,
                loadingPrimary: true,
                loadingSecondary: true,
                userParams: {
                    additionalContact: {
                        email: '',
                        mobile: '',
                        mobileISD: '91',
                        isEmailValid: false
                    },
                    emailId: '',
                    mobileNo: '',
                    userId: '',
                    title: '',
                    firstName: '',
                    lastName: '',
                    mobileNoISD: ''
                },
                isGstMandatory: false,
                gstNumber: '',
                companyName: '',
                email: '',
                mobileNumber: '',
                isdCode: '91',
                selectedOption: {
                    value : "91",
                    label : "+ 91"
                },
                isGstAdded: false,
                nationality: "",
                number: "",
                issuingCountryCode: "",
                issuingCountryName: "",
                expiryDate: "",
                mealsViewOneWay: null,
                mealsViewReturn: null,
                mealsViewOneWayVal: 0,
                mealsViewReturnVal: 0,
                baggageViewOneWay: null,
                baggageViewReturn: null,
                baggageViewOneWayVal: 0,
                baggageViewReturnVal: 0,
                seatsViewOneWay: null,
                seatsViewReturn: null,
                seatsViewOneWayVal: 0,
                seatsViewReturnVal: 0,
                mealsFlow: 'O',
                baggageFlow: 'O',
                seatsFlow: 'O',
                baggageWeight: null,
                selectedMeals: {
                    O: {},
                    R: {}
                },
                selectedBaggage: {
                    O: {},
                    R: {}
                },
                savedBaggage: {},
                savedSeat: {},
                selectedSeats: [],
                mealChanged: false,
                showBaggageView: 'initial',
                savedBaggagePaxId: [],
                displayPax: true,
                addonList: null,
                showTravellerInsurance: false,
                isBBG: false,
                isSDFC: false,
                isInsuranceAdded: true,
                isAssureAdded: true,
                dfcBenefits: null,
                showBaggageIndex: 10,
                timeoutTime: null
            }
        case actionTypes.CLOSE_PAX:
            return {
                ...state,
                displayPax: false
            }
        case actionTypes.SHOW_PAX:
            return {
                ...state,
                displayPax: true
            }
        case actionTypes.ADD_INSURANCE:
            return {
                ...state,
                isInsuranceAdded: true
            }
        case actionTypes.ADD_ASSURE:
            return {
                ...state,
                isAssureAdded: true
            }
        case actionTypes.ADD_ADDON:
            console.log(action.addon);
            const addonsArray = JSON.parse(JSON.stringify(state.addonList));
            let isAddonPresent = false;
            for(let i = 0; i < addonsArray.length; i++) {
                if(action.addon.addonLabel === addonsArray[i].addonLabel && action.addon.legIndex === addonsArray[i].legIndex && action.addon.leg === addonsArray[i].leg) {
                    console.log("Reached in");
                    console.log(addonsArray);
                    addonsArray[i].amount += action.addon.amount;
                    console.log(addonsArray);
                    isAddonPresent = true;
                    break;
                }
            }
            console.log('After Add Addon', state.addonList);
            if(!isAddonPresent) {
                addonsArray.push(action.addon);
            }
            return {
                ...state,
                addonList: addonsArray
            }
        case actionTypes.REMOVE_ADDON:
            let addons = JSON.parse(JSON.stringify(state.addonList));
            for(let i = 0; i < state.addonList.length; i++) {
                if(action.label === state.addonList[i].addonLabel && action.legIndex === state.addonList[i].legIndex && action.leg === state.addonList[i].leg ) {
                    if(state.addonList[i].amount - action.amount === 0) {
                        addons.splice(i, 1);
                    } else {
                        addons[i].amount -= action.amount;                                                   
                    }                                        
                    break;
                }
            }

            if(action.label === "Travel Assistance and Insurance") {
                return {
                    ...state,
                    addonList: addons,
                    isInsuranceAdded: false
                }
            } else if(action.label === "Assure") {
                return {
                    ...state,
                    addonList: addons,
                    isAssureAdded: false
                }
            } else {
                return {
                    ...state,
                    addonList: addons
                }
            }
        case actionTypes.REMOVE_ADDON_FROM_FARE_PRICE:
            const addonsCopy = JSON.parse(JSON.stringify(state.addonList));
            for(let i = 0; i < state.addonList.length; i++) {
                if(action.label === state.addonList[i].addonLabel) {
                    const index = addonsCopy.findIndex(addon => addon.addonLabel === action.label);
                    if(index > -1) {
                        addonsCopy.splice(index, 1);
                    }
                    console.log(addonsCopy);
                }
                console.log(state.addonList);
            }

            let temPassengers = JSON.parse(JSON.stringify(state.passengers));
            let ssrType = null;

            for(let i = 0; i < temPassengers.length; i++) {
                if(action.label === "Meals") {
                    ssrType = "ssrMealDetails";
                } else if (action.label === "Seats") {
                    ssrType = "ssrSeatDetails";
                } else if(action.label === "Baggage") {
                    ssrType = "ssrBaggageDetails"
                }
                if(action.label === "Meals" || action.label === "Seats" || action.label === "Baggage") {
                    Object.keys(temPassengers[i].ssrDetails[ssrType][0][0]).forEach(key => temPassengers[i].ssrDetails[ssrType][0][0][key] = "");
                    Object.keys(temPassengers[i].ssrDetails[ssrType][0][1]).forEach(key => temPassengers[i].ssrDetails[ssrType][0][1][key] = "");
                    Object.keys(temPassengers[i].ssrDetails[ssrType][0][2]).forEach(key => temPassengers[i].ssrDetails[ssrType][0][2][key] = "");
                    Object.keys(temPassengers[i].ssrDetails[ssrType][1][0]).forEach(key => temPassengers[i].ssrDetails[ssrType][1][0][key] = "");
                    Object.keys(temPassengers[i].ssrDetails[ssrType][1][1]).forEach(key => temPassengers[i].ssrDetails[ssrType][1][1][key] = "");
                    Object.keys(temPassengers[i].ssrDetails[ssrType][1][2]).forEach(key => temPassengers[i].ssrDetails[ssrType][1][2][key] = "");
                }       
            }

            if(action.label === "Travel Assistance and Insurance") {
                return {
                    ...state,
                    addonList: addonsCopy,
                    isInsuranceAdded: false
                }
            } else if (action.label === "Assure") {
                return {
                    ...state,
                    addonList: addonsCopy,
                    isAssureAdded: false
                }
            } else {
                return {
                    ...state,
                    addonList: addonsCopy,
                    passengers: temPassengers
                }
            }
        case actionTypes.SET_GST_DETAILS:
            return {
                ...state,
                [action.name] : action.value
            }
        case actionTypes.CLEAR_GST_DETAILS:
            return {
                ...state,
                gstNumber: '',
                companyName: '',
                email: '',
                mobileNumber: '',
                isdCode: '91',
                selectedOption: {
                    value : "91",
                    label : "+ 91"
                },
                isGstAdded: false
            }
        case actionTypes.ADD_GST:
            let isGstAdded = false;
            if(state.gstNumber && state.companyName && state.email && state.mobileNumber) {
                isGstAdded = true;
            }
            return {
                ...state,
                isGstAdded: isGstAdded
            }
        default: 
            return state;
    }
}

const validateEmail = (value) => {
    const emailFormat = /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,8})+$/;
    if(value.match(emailFormat)) {
        return true;
    } else {
        return false;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/farePrice.js